export type KullaniciRol =
  | "Admin"
  | "Muhasebe"
  | "Kesim Alanı"
  | "Taşıyıcı"
  | "Müşteri"
  | "Sıra Operatörü"
  | "Kesim Operatörü"
  | "Parçalama Operatörü"
  | "Tamamlama Operatörü";
export type KullaniciDurum = "Aktif" | "Pasif";

export interface KullaniciItem {
  id: number;
  adSoyad: string;
  telefon: string;
  email?: string;
  username?: string;
  rol: KullaniciRol;
  durum: KullaniciDurum;
  eklemeTarihi: string;
  sonGiris?: string;
}

export const rolColors: Record<KullaniciRol, { bg: string; text: string; border: string }> = {
  Admin: { bg: "bg-red-100", text: "text-red-700", border: "border-red-200" },
  Muhasebe: { bg: "bg-amber-100", text: "text-amber-700", border: "border-amber-200" },
  "Kesim Alanı": { bg: "bg-orange-100", text: "text-orange-700", border: "border-orange-200" },
  Taşıyıcı: { bg: "bg-sky-100", text: "text-sky-700", border: "border-sky-200" },
  Müşteri: { bg: "bg-green-100", text: "text-green-700", border: "border-green-200" },
  "Sıra Operatörü": { bg: "bg-indigo-100", text: "text-indigo-700", border: "border-indigo-200" },
  "Kesim Operatörü": { bg: "bg-rose-100", text: "text-rose-700", border: "border-rose-200" },
  "Parçalama Operatörü": { bg: "bg-violet-100", text: "text-violet-700", border: "border-violet-200" },
  "Tamamlama Operatörü": { bg: "bg-teal-100", text: "text-teal-700", border: "border-teal-200" },
};

export const rolIcons: Record<KullaniciRol, string> = {
  Admin: "ri-shield-star-line",
  Muhasebe: "ri-calculator-line",
  "Kesim Alanı": "ri-scissors-2-line",
  Taşıyıcı: "ri-truck-line",
  Müşteri: "ri-user-line",
  "Sıra Operatörü": "ri-play-circle-line",
  "Kesim Operatörü": "ri-scissors-cut-line",
  "Parçalama Operatörü": "ri-layout-grid-line",
  "Tamamlama Operatörü": "ri-checkbox-circle-line",
};

export const kullanicilar: KullaniciItem[] = [];
